import { Component, Input } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService } from 'src/app/services/common/common.service'

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() pageTitle: any
  @Input() backRouting: any

  constructor(private cs: CommonService) {}

  back() {
    this.cs.route(this.backRouting)
  }
}
